import styled from 'styled-components';

import * as grid from 'view/styles/grid';
import { FieldSingleSelect } from 'view/common/form-select';
import { token } from '@atlaskit/tokens';

export const IconWrap = styled.span`
    margin-right: ${token('space.050', '4px')};
`;

export const OrganisationPicker = styled(FieldSingleSelect)`
    display: inline-block;
    min-width: ${grid.multiple(30).px};
`;
